<template>
  <v-layout row wrap align-content-start fill-height class="px-4">
    <v-flex xs12 class="page-head-container mb-3">
      <v-flex v-if="getDoctors.length > 0" xs12>
        <v-data-table
          :headers="headers"
          :items="getDoctors"
          :pagination.sync="pagination"
          hide-actions
          class="my-4"
          :disable-initial-sort="true"
        >
          <template #headers>
            <tr>
              <th
                v-for="header in headers"
                :key="header.text"
                :class="[
                  'column sortable',
                  pagination.order ? 'desc' : 'asc',
                  header.value === pagination.title ? 'active' : '',
                ]"
                @click="changeSort(header.value)"
              >
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>

          <template #items="props">
            <td class="text-xs-center">{{ props.item.name }}</td>
            <td class="text-xs-center">{{ props.item.idNo }}</td>
            <td :class="['text-xs-center', status_color(props.item.status)]">{{ '排序' }}</td>
            <td class="text-xs-center">
              <v-btn
                flat
                icon
                color="primary"
                @click="toggle(true, props.item)"
              >
                <v-icon small>edit</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-flex>

    <v-btn icon fixed bottom right fab color="primary" @click="toggle(true)">
      <v-icon>add</v-icon>
    </v-btn>
    <doctor-dialog v-model="dialog" :current="current" @show="toggle" />
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import DoctorDialog from '@/components/doctor-dialog'

export default {
  name: 'AdminDoctorList',
  components: {
    DoctorDialog,
  },
  data() {
    return {
      search: '',
      pagination: {
        rowsPerPage: -1,
        title: '',
        order: false,
      },
      headers: [
        {
          text: 'Name',
          value: 'name',
        },
        {
          text: 'ID Number',
          value: 'idNo',
        },
        {
          text: '排序',
          value: 'status',
        },
      ],
      dialog: false,
      current: null,
    }
  },

  created() {
    this.fetchDoctors()
  },

  computed: {
    ...mapGetters('doctors', ['getDoctors']),
  },

  methods: {
    ...mapActions('doctors', ['fetchDoctors']),
    changeSort(column) {
      if (column === '') {
        return
      }
      if (this.pagination.title === column) {
        this.pagination.order = !this.pagination.order
      } else {
        this.pagination.title = column
        this.pagination.order = false
      }
      this.$store.dispatch('doctors/sortDoctor', {
        title: column,
        order: this.pagination.order,
      })
    },
    toggle(status, doctor) {
      this.dialog = status

      if (status) {
        this.current = doctor
      } else {
        this.current = null
      }
    },
    status_color(s) {
      return s == '2' ? 'orange--text' : 'grey--text'
    },
  },
}
</script>
